import { LegalGuardianType } from './../../../../core/domain/data/enum/legal-guardian-type.enum';
import { MeetingDetails } from './../../../domain/data/meeting-details';
import { ActivatedRoute, Router } from '@angular/router';
import { AfterViewInit, Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { ConfirmTransferDialog } from 'src/app/main/ui/dialog/confirm-transfer/confirm-transfer.dialog';
import { cloneDeep } from 'lodash';
import { BasePage } from '../../base.page';
import { ErrorDialog } from '../../../ui/dialog/error/error.dialog';
import {
    ClientType,
    ContractInterface,
    ContractSignatureType,
    GetOperationUseCase,
    GetOptimalSelectedProductUseCase,
    GetSelectedProductSignatoriesUseCase,
    Nature,
    OrderClientInterface,
    OrderType,
    OrderTypeAvailableInterface,
    ProductInterface,
    SelectedProductInterface,
    UpdateOperationUseCase,
} from '../../../../core';
import { Assistants, Id, Initiators } from '../../../domain/data';
import { LocalStorage } from '../../../client/helpers/local-storage';
import { MainRoutes } from '../../../main-routes.enum';
import { OperativePage } from '../operative.page';
import { ParentEvents } from '../../../utils/parent-events.service';

import { environment } from '../../../../../environments/environment';

@Component({
    templateUrl: './meeting-sign.page.html',
    styleUrls: ['./meeting-sign.page.scss'],
})
export class MeetingSignPage extends BasePage implements AfterViewInit, OnDestroy, OnInit {
    public OrderType: typeof OrderType = OrderType;

    private backSubscription: Subscription;

    public participants = [];
    public authoriseds = [];
    public contract: ContractInterface;
    public product: ProductInterface;
    public selectedProduct: SelectedProductInterface;
    public isClientPortal = environment.portalClient;
    public assistantsList = [];
    public initiatorsList = [];
    public assistants: Assistants[] = [];
    public initiators: Initiators[] = [];
    public isAgent = false;
    public agentName: string;
    public agentSurname: string;
    public agentUserId: string;
    public selectedDateTime: string;
    public editing = false;
    public initiatorSelected = undefined;
    public agentSelected: boolean = undefined;
    public allInitiators: boolean = undefined;
    public checkedAssistants;
    private selectedProductOriginal: SelectedProductInterface;
    public onlyRefund = false;
    public readonly = true;
    public allowedTypes: OrderTypeAvailableInterface[] = [];

    @Input()
    meetingDetails: MeetingDetails;

    @ViewChild('formMeetingSign') form;

    constructor(
        operativePage: OperativePage,
        parentEvents: ParentEvents,
        private dialog: MatDialog,
        private getOperationUseCase: GetOperationUseCase,
        private getSelectedProductSignatoriesUseCase: GetSelectedProductSignatoriesUseCase,
        private localStorage: LocalStorage,
        private route: ActivatedRoute,
        private router: Router,
        private updateOperationUseCase: UpdateOperationUseCase,
        private getOptimalSelectedProductUseCase: GetOptimalSelectedProductUseCase
    ) {
        super(parentEvents);
        operativePage.showBackButton();
        this.backSubscription = operativePage.back.subscribe(() => {
            window.history.back();
        });
    }

    getAssistants(data) {
        data.forEach((participant, i) => {
            if (participant.type == 'NaturalPerson' || participant.type == 'Disabled') {
                var asistente = new Assistants();
                asistente.ClientId = participant.id.value;
                asistente.Checked = false;
                this.assistants.push(asistente);
            }
        });
        this.selectedProduct.meetingDetails.assistants = this.assistants;
    }

    getInitiators(data) {
        var initiatorAgent = new Initiators();
        initiatorAgent.ClientId = '';
        initiatorAgent.UserId = this.agentUserId;
        initiatorAgent.Checked = false;
        this.initiators.push(initiatorAgent);

        data.forEach((participant, i) => {
            if (participant.type == 'NaturalPerson' || participant.type == 'Disabled') {
                var initiatorParticipant = new Initiators();
                initiatorParticipant.ClientId = participant.id.value;
                initiatorParticipant.UserId = '';
                initiatorParticipant.Checked = false;
                this.initiators.push(initiatorParticipant);
            }
        });
        this.selectedProduct.meetingDetails.initiators = this.initiators;
    }

    assistantsToggleCheckbox(event, participant) {
        this.selectedProduct.meetingDetails.assistants.map((assistant, i) => {
            if (assistant.ClientId === participant.id.value) {
                this.selectedProduct.meetingDetails.assistants[i].Checked = event.checked;
            }
        });
        this.checkedAssistants = this.assistants.some((assistant) => assistant.Checked === true);
    }

    initiatorsToggleCheckbox(event, participant) {
        this.initiatorSelected = event.checked;

        if (event.checked || this.agentSelected) {
            this.allInitiators = true;
        } else {
            this.allInitiators = false;
        }
        this.selectedProduct.meetingDetails.initiators.map((initiator, i) => {
            if (initiator.ClientId === participant.id.value) {
                this.selectedProduct.meetingDetails.initiators[i].Checked = event.checked;
            }
        });
    }

    agentToggleCheckbox(event) {
        this.agentSelected = event.checked;

        if (event.checked || this.initiatorSelected) {
            this.allInitiators = true;
        } else {
            this.allInitiators = false;
        }
        this.selectedProduct.meetingDetails.initiators.map((initiator, i) => {
            if (initiator.UserId === event.source.value) {
                this.selectedProduct.meetingDetails.initiators[i].Checked = event.checked;
            }
        });
    }

    get signedBy(): 'all' | 'one' {
        if (
            this.contract &&
            (this.contract.signatureType === ContractSignatureType.JOINT ||
                this.contract.signatureType === ContractSignatureType.CONDITIONAL_JOINT)
        ) {
            return 'all';
        }

        return 'one';
    }

    get allowDigital(): boolean {
        return !this.contract || this.contract.signatureType !== ContractSignatureType.CONDITIONAL_JOINT;
    }

    get allowHandwritten(): boolean {
        return !this.isClientPortal;
    }

    ngOnInit() {
        this.agentName = localStorage.getItem('UserName');
        this.agentSurname = localStorage.getItem('UserSurname');
        this.agentUserId = localStorage.getItem('UserId');
        this.getSignatories();
        this.getOperation();
    }

    ngAfterViewInit() {
        super.ngAfterViewInit();
    }

    private getOperation() {
        this.getOperationUseCase.bind().subscribe((transaction) => {
            transaction.fold(
                (operation) => {
                    this.contract = operation.contract;
                    this.product = operation.product;
                    this.selectedProduct = operation.selectedProduct;
                    this.selectedProductOriginal = cloneDeep(operation.selectedProduct);
                    this.allowedTypes = operation.types;
                    this.onlyRefund = operation.onlyRefund;
                    this.editing = operation.editing;
                    this.readonly = operation.readonly;

                    if (this.contract.authorized.length != 0) {
                        this.participants = this.contract.holders.concat(this.contract.authorized);
                    } else {
                        if(this.contract.holders[0].nature === Nature.COMPANY || this.contract.holders[0].type === ClientType.MINOR){
                            this.contract.holders.map((holder, i) => {
                            this.participants = this.contract.holders[i].legalGuardians;
                            });
                        }
                        else{
                            this.participants = this.contract.holders;
                        }
                    }

                    this.getAssistants(this.participants);
                    this.getInitiators(this.participants);

                    if (this.onlyRefund) {
                        this.product = operation.original.product;
                        this.selectedProduct = operation.original.selectedProduct;
                        this.selectedProductOriginal = cloneDeep(operation.original.selectedProduct);
                    }
                    if (!this.allowedTypes.find((it) => it.type === this.selectedProduct.order.type)) {
                        this.selectedProduct.order.type = this.allowedTypes[0].type;
                    }
                },
                (throwable) => {
                    this.router.navigateByUrl(MainRoutes.OPERATIVE_LIST);
                    this.dialog.open(ErrorDialog, {
                        data: { text: throwable.message },
                    });
                }
            );
        });
    }
    private getSignatories() {
        this.getOperationUseCase.bind().subscribe((transaction) => {
            if (transaction.isSuccess) {
                this.contract = transaction.data.contract;
                this.selectedProduct = transaction.data.selectedProduct;

                this.getSelectedProductSignatoriesUseCase
                    .bind({
                        product: this.selectedProduct,
                        clientCode: Id.fromString(this.localStorage.clientCode),
                    })
                    .subscribe(
                        (transactionSignatories) => {
                            transactionSignatories.fold((signatories) => {
                                if (!signatories || signatories.length === 0) {
                                    this.dialog.open(ErrorDialog, {
                                        data: {
                                            text: 'dialog.operate.cannot-sign',
                                        },
                                        disableClose: true,
                                    });
                                }
                            });
                        },
                        (_) =>
                            this.dialog.open(ErrorDialog, {
                                data: {
                                    text: 'error.selected-product-not-signatories',
                                },
                            })
                    );
            } else if (!transaction.isAuthError) {
                this.dialog.open(ErrorDialog, {
                    data: { text: 'error.selected-product-not-signatories' },
                });
            }
        });
    }

    ngOnDestroy() {
        this.backSubscription.unsubscribe();
    }

    onCancel() {
        this.router.navigateByUrl(MainRoutes.OPERATIVE_LIST);
    }

    onChangeDate(value) {
        this.selectedProduct.meetingDetails.date = value;
    }

    onChangePlace(value) {
        this.selectedProduct.meetingDetails.place = value;
    }

    onChangeNotes(value) {
        this.selectedProduct.meetingDetails.notes = value;
    }

    onSubmit() {
        const productClone = JSON.parse(JSON.stringify(this.selectedProduct));
        this.selectedProduct.order.clients = this.participants.filter((participant) => !!participant.signatureType);

        const updateOperation = (product: SelectedProductInterface, redirect = true) => {
            this.updateOperationUseCase
                .bind({
                    selectedProduct: product,
                    clientCode: Id.fromString(this.localStorage.clientCode),
                })
                .subscribe((transaction) => {
                    transaction.fold(
                        () => {
                            if (redirect) {
                                this.router.navigateByUrl(MainRoutes.OPERATIVE_SIGN + (this.editing ? '?update=1' : ''));
                            } else {
                                this.getOperation();
                            }
                        },
                        (throwable) =>
                            this.dialog.open(ErrorDialog, {
                                data: { text: throwable.message },
                            })
                    );
                });
        };
        updateOperation(this.selectedProduct, true);
    }
}
